import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, PieChart, Pie, Cell } from 'recharts';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';

const OrganizationChart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const fetchData = async () => {
    try {
      const response = await axios.get('https://ward3-chandrapur-api.palikaapp.com/api/organization/count-org-type');
      const formattedData = response.data.map(item => ({
        type: item[0],
        value: item[1],
      }));
      setData(formattedData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const COLORS = ['#1890ff', '#f5222d', '#52c41a', '#faad14', '#13c2c2'];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex flex-1 pt-20">
        <Sidebar 
          toggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} 
          collapsed={sidebarCollapsed}
        />
        
        <main 
          className="flex-1 ml-20 px-10 sm:p-6 lg:p-8"
        >
          <h1 className="text-2xl font-bold mb-6 text-start px-20 ml-20 pt-5">सँस्थाको मानचित्र</h1>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-5 ml-10">
            {/* Bar Chart Card */}
            <div className="bg-white rounded-lg shadow-md p-4">
              <h2 className="text-xl font-semibold text-center mb-4">
                संस्थाको प्रकार - Bar Chart
              </h2>
              {loading ? (
                <div className="flex justify-center items-center h-64">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <BarChart
                    width={500}
                    height={400}
                    data={data}
                    className="mx-auto"
                    margin={{ top: 20, right: 30, bottom: 5, left: 20 }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="type" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="value" fill="#1890ff" />
                  </BarChart>
                </div>
              )}
            </div>

            {/* Pie Chart Card */}
            <div className="bg-white rounded-lg shadow-md p-4">
              <h2 className="text-xl font-semibold text-center mb-4">
                संस्थाको प्रकार - Pie Chart
              </h2>
              {loading ? (
                <div className="flex justify-center items-center h-64">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <PieChart 
                    width={500} 
                    height={400} 
                    className="mx-auto"
                  >
                    <Pie
                      data={data}
                      dataKey="value"
                      nameKey="type"
                      outerRadius={150}
                      fill="#8884d8"
                      label={({ index }) => `${data[index].type}`}
                    >
                      {data.map((entry, index) => (
                        <Cell 
                          key={`cell-${index}`} 
                          fill={COLORS[index % COLORS.length]} 
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default OrganizationChart;